import React from 'react';
import { useGlobal, Card, CardContent } from '@rcg/ui-react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// eslint-disable-next-line import/no-extraneous-dependencies
import clsx from 'clsx';
import useStyles from './index.styles';
import FlightsExpanded from './FlightsExpanded';
import Dictionary from '../../commons/dictionary';
import useDictionary from '../../hooks/useDictionary';
import { ReactComponent as OneWayTrip } from '../../assets/svg/OneWayTrip.svg';
import { ReactComponent as RoundTrip } from '../../assets/svg/roundTrip.svg';
import { capitalizeText, groupAirGuest } from '../../commons/utils';
import { ROUTE_TYPES } from '../../commons/constants';

export const FlightCard = ({ cardInformation, index, expanded, handleExpanded }) => {
  const {
    flightsPerLocator: { type, flights, confirmationNumber },
    allowCancellation,
    allowReshop,
    gdsLocator,
  } = cardInformation;

  const classes = useStyles();
  const {
    data: { localizedDayjs },
    renderContent,
  } = useGlobal();

  const getDictionaryValue = useDictionary(Dictionary);
  const typeOfFlight = type?.flightType;

  const mapTypeOfFlightNames = {
    Roundtrip: getDictionaryValue(Dictionary.amendFlightTypeRoundtrip.key),
    'One way': getDictionaryValue(Dictionary.amendFlightTypeOneWay.key),
    'Multi-city': getDictionaryValue(Dictionary.amendFlightTypeMultiCity.key),
  };

  return (
    <Card className={classes.mainCard}>
      <CardContent
        className={`${classes.mainCardContainer} ${expanded && 'expandedMode'}`}
        onClick={() => {
          handleExpanded(index);
        }}
        data-testid="handle-expanded-button">
        <div className={classes.flightsContainer}>
          <div className="flightInfo">
            <div>
              <div className="typeOfTrip">{mapTypeOfFlightNames[typeOfFlight]}</div>
              <div
                className={`${typeOfFlight === ROUTE_TYPES.MULTI_CITY && 'flightTypeContainer'}`}>
                <div className="flightCodeDestination">
                  {type?.departure}
                  {typeOfFlight === ROUTE_TYPES.ROUND_TRIP ? <RoundTrip /> : <OneWayTrip />}
                  {type?.arrival}{' '}
                </div>
                {typeOfFlight === ROUTE_TYPES.MULTI_CITY && (
                  <span className="dividerSlash flightCodeDestination"> / </span>
                )}
                {typeOfFlight === ROUTE_TYPES.MULTI_CITY && (
                  <div className="flightCodeDestination">
                    {type?.multyCity} <OneWayTrip /> {type?.departure}{' '}
                  </div>
                )}
              </div>
            </div>
            <div className="roundTr departDate">
              {typeOfFlight === ROUTE_TYPES.ONE_WAY_TRIP ? (
                <>{localizedDayjs(flights[0]?.departDate).format('MMM D, YYYY')}</>
              ) : (
                <>
                  {localizedDayjs(flights[0]?.departDate).format('MMM D')}
                  &nbsp;-&nbsp;
                  {localizedDayjs(flights[1]?.departDate).format('MMM D, YYYY')}
                </>
              )}
            </div>
          </div>
          <div
            id={`${typeOfFlight === ROUTE_TYPES.MULTI_CITY && 'multiCityCase'}`}
            className="tripDetails">
            <div className="planeInfo">
              <div className="confNumber">
                {confirmationNumber.map((item) => {
                  return <div key={item}>{item.replace('/', ' / ')}</div>;
                })}
              </div>
              <div className="confirmationNumbers">
                {confirmationNumber.length > 1
                  ? renderContent('displayingFlightsConfirmationNumbers', `Confirmation numbers`)
                  : renderContent('displayingFlightsConfirmationNumber', `Confirmation number`)}
              </div>
            </div>
            <div className="passengerInfo">
              <div className="passengers">
                {cardInformation.passengerCount}{' '}
                {cardInformation.passengerCount > 1
                  ? renderContent('displayingFlightsPassengers', `passengers`)
                  : renderContent('displayingFlightsPassenger', `passenger`)}
              </div>
              <div className="passengersNames">{capitalizeText(cardInformation.names)}</div>
            </div>
          </div>
          <div className="expandMoreContainer">
            <ExpandMoreIcon
              className={clsx(classes.expand, {
                [classes.expandOpen]: expanded[index],
              })}
            />
          </div>
        </div>
      </CardContent>
      <FlightsExpanded
        expanded={expanded}
        index={index}
        flightDetails={flights}
        passengers={cardInformation.names}
        allowCancellation={allowCancellation}
        allowReshop={allowReshop}
        locators={gdsLocator}
        cardInformation={cardInformation}
        isOneWayFlight={typeOfFlight === ROUTE_TYPES.ONE_WAY_TRIP}
      />
    </Card>
  );
};

const DisplayingFlights = ({ expanded, handleExpanded, flightProfile }) => {
  const cardInformation = groupAirGuest(flightProfile);

  return cardInformation.map((card, index) => (
    <FlightCard
      key={card.gdsLocatorString}
      index={index}
      expanded={expanded}
      handleExpanded={handleExpanded}
      flightProfile={flightProfile}
      cardInformation={card}
    />
  ));
};

export default DisplayingFlights;
